import { measurementUnits } from "../../../../Utils/Utils";
import { useFormik } from "formik";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useIsMobile } from "../../../../Utils/ResizeUtils";
import { useLocation, useNavigate } from "react-router-dom";

import CommonToolbar from "../../../UIElements/CommonToolbar";
import CurrencyAmountInput from "../../../UIElements/Inputs/CurrencyAmountInput";
import DropdownInput from "../../../UIElements/Inputs/DropdownInput";
import EnumsContext from "../../../../context/enums-context";
import HistoryElement from "../../../UIElements/HistoryElement";
import NumberInput from "../../../UIElements/Inputs/NumberInput";
import ProductsAndServicesPickerSidebar from "../../../UIElements/ProductsAndServicesPickerSidebar";
import TextInput from "../../../UIElements/Inputs/TextInput";
import useApi from "../../../../Utils/BackendClient";
import useGetEnums from "../../../../Utils/EnumsUtils";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { TabMenu } from "primereact/tabmenu";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";

import commonStyle from "../../CommonStyles.module.css";
import { DisplayErrors } from "../../../../Utils/ErrorHandler";

const ExternalProductDetails = () => {

    const ctx = useContext(EnumsContext);
    const isMobile = useIsMobile();
    const location = useLocation();
    const navigate = useNavigate();
    const toast = useRef();

    const { createExternalProduct, fetchExternalProductDetails, fetchExternalProductHistory, fetchProductDetails, updateExternalProduct } = useApi();

    const enumTypes = useMemo(() => ["partners", "brands_dictionary"], []);

    useGetEnums(enumTypes);
 
    const [catalogueProduct, setCatalogueProduct] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [historyLazyState, setHistoryLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1   
    });
    const [historyTotalRecords, setHistoryTotalRecords] = useState(0);
    const [product, setProduct] = useState({
        name: null,
        cagent_id: null,
        brand_id: null,
        price: null,
        currency: "UAH",
        measurement_units: "PIECES",
        product_id: null,
        quantity: null,
        identifier: null,
        external_data: null
    });
    const [productHistory, setProductHistory] = useState(null);
    const [tabShowed, setTabShowed] = useState(0);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (location.state !== null) {

            setIsEdit(true);

            const fetchData = async () => {
                const response = await fetchExternalProductDetails(location.state.id);

                if (response.status === 200) {

                    console.log(response.data);
                    setProduct(response.data);

                    if(response.data.product_id){
                        const productResponse = await fetchProductDetails(response.data.product_id);

                        setCatalogueProduct([productResponse.data]);
                    }
                }
            }

            fetchData();
        }
    },[fetchExternalProductDetails, fetchProductDetails, location]);

    const formik = useFormik({
        initialValues: product,
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            if (!values.name || values.name === "") {
                errors.name = "Введіть назву товару";
            }

            if (!values.cagent_id) {
                errors.division = "Виберіть контрагента";
            }

            if (values.quantity === null) {
                errors.quantity = "Виберіть кількість";
            }
            else if (values.quantity === 0){
                errors.quantity = "Kількість повинна бути більшою від 0";
            }

            return errors;
        },
        onSubmit: async (values) => {

            setSubmitLoading(true);

            const response = isEdit ? await updateExternalProduct(location.state?.id, values) : await createExternalProduct(values);

            setSubmitLoading(false);

            const successStatus = isEdit ? 200 : 201;

            if (response.status === successStatus) {
                const toastMessage = isEdit ? { severity: "success", summary: "Успіх редагування", detail: "Товар успішно відредаговано", life: 3000 } :
                    { severity: "success", summary: "Успіх створення", detail: "Товар успішно створено", life: 3000 }
                navigate("/externalproducts", { state: { toast: toastMessage } });
            }
            else {
                DisplayErrors(response.error, toast);
            }
        }
    });

    const confirmLeave = (event) => {

        if (formik.values !== product) {

            confirmDialog({
                group: 'headless',
                header: 'Незбережені зміни',
                message: 'У вас є незбережені зміни. Ви впевнені, що хочете залишити цю сторінку?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: "Так",
                rejectLabel: "Hi",
                defaultFocus: 'accept',
                accept: () => { navigate('/externalproducts', { state: { productPageState: location.state?.productPageState } }) }
            });

        }
        else {
            navigate('/externalproducts', { state: { productPageState: location.state?.productPageState } });
        }
    }

    const AddProductHandler = () => {
        setVisible(true);
    }

    const SelectionHandler = (obj) => {
        setCatalogueProduct([obj]);
        formik.setFieldValue("product_id", obj.id);
    }

    const getExternalProductHistory = async (id, state) => {

        const response = await fetchExternalProductHistory(id, state);

        if (response.status === 200) {
            setProductHistory(response.data.results);
            setHistoryTotalRecords(response.data.count);
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка отримання історії", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const onHistoryPage = (event) => {
        event.page = event.page + 1;
        getExternalProductHistory(location.state.id, event);

        setHistoryLazyState(event);
    }

    const items = [
        {
            label: isMobile ? "Деталі" : "Деталі товару",
            icon: 'pi pi-book',
            command: () => {
                setTabShowed(0);
            },
        },
        ...(isEdit
            ?[
                {
            label: 'Історія',
            icon: 'pi pi-history',
            command: () => {
                setTabShowed(1);
                getExternalProductHistory(location.state.id, historyLazyState);
            },
            },
        ]
        : [])
    ];

    const toolbarLeftData = () => {

        let name = "Створення залишку контрагента";

        if (isEdit) {
            name = "Редагування залишку контрагента: " + formik.values.name;
        }
        return !isMobile ? <h3>{name}</h3> : null;
    };

    const tableHeader = () => {
        return (<Toolbar className="mb-1" start={<h3> Прикріплений товар з довідника </h3> } end={contentToolbarRightTemplate} style={{ border: 'none' }}/>);
    }

    const contentToolbarRightTemplate = () => {
         return (<>
            <div className="flex flex-wrap gap-2">
                <Button label={`${isMobile ? "" : "+Додати товар з каталогу"}`} icon={`${isMobile ? "pi pi-plus" : null}`}severity="success" className={commonStyle.addButton} type="button" onClick={AddProductHandler} />
            </div>
        </>);
    }

    const imageBodyTemplate = (product) => {
        return <img src={product.logo} alt={product.image} className={`${isMobile ? "w-4rem" : "w-8rem"} "shadow-2 border-round"`} />;
    };

    return (<form onSubmit={formik.handleSubmit}>
        <Toast ref={toast} />
        <CommonToolbar isMobile={isMobile} isFinalized={false} loading={submitLoading} onRetunButtonClick={(event) => confirmLeave(event)} leftContent={toolbarLeftData()} />
        <ConfirmDialog group="headless" />
        <TabMenu model={items} />
        {tabShowed === 0 && <div className="grid nested-grid">
            <div className={`${commonStyle.leftMenu} col-3`}>
                <TextInput formik={formik} paramName="name" label="Назва товару" mandatory/>
                    <DropdownInput
                        formik={formik}
                        paramName={"cagent_id"}
                        label={"Контрагент"}
                        onChange={(val) => formik.setFieldValue("cagent_id", val)}
                        context={ctx.enums.partners.data}
                        mandatory
                    />
                    <CurrencyAmountInput
                        amount={formik.values.price}
                        currency={formik.values.currency}
                        onAmountChange={(val) => formik.setFieldValue("price", val)}
                        onCurrencyChange={(val) => formik.setFieldValue("currency", val)}
                    />
                    <DropdownInput
                        formik={formik}
                        paramName={"brand_id"}
                        label={"Бренд"}
                        onChange={(val) => formik.setFieldValue("brand_id", val)}
                        context={ctx.enums.brands_dictionary.data}
                    />
                    <DropdownInput
                        formik={formik}
                        value={formik.values.measurement_units}
                        paramName="measurement_units"
                        label="Одиниця виміру"
                        onChange={(val) => formik.setFieldValue("measurement_units", val)}
                        context={measurementUnits}
                    />
                    <NumberInput
                        label="Кількість" 
                        value={formik.values.quantity} 
                        onChange={(val) => formik.setFieldValue('quantity', val)}
                        errors={formik.errors.quantity}
                        touched={formik.touched.quantity}
                        mandatory
                    />
                    <TextInput
                        formik={formik}
                        paramName="identifier"
                        label="Ідентифікатор"
                    />
            </div>
            <div className="col-9">
                <DataTable value={catalogueProduct} header={tableHeader}>
                    <Column field="logo" body={imageBodyTemplate} style={{ width: '5%' }} headerStyle={{ display: 'none' }}/>
                    <Column field="product_name" headerStyle={{ display: 'none' }}/>
                </DataTable>
            </div>
        </div>}
        {tabShowed === 1 && <HistoryElement data={productHistory} lazyState={historyLazyState} totalRecords={historyTotalRecords} onHistoryPage={onHistoryPage} isAct={true}/>}
        <ProductsAndServicesPickerSidebar sbVisible={visible} onHide={() => setVisible(false)} type={"products"} onSelect={SelectionHandler}/>
    </form>);
}

export default ExternalProductDetails;